module.exports = __webpack_public_path__ + "img/site-0-0.6af565f2.svg";